import {
  EngagementSurveyQuestionAnswerFragmentDoc,
  useAnswerEngagementSurveyQuestionMutation,
} from '../../../__generated__/graphql';
import { Reference } from '@apollo/client';

// it handles update of EngagementSurveyEmployeeResponse properly
export const useAnswerEngagementSurveyQuestion = () => {
  return useAnswerEngagementSurveyQuestionMutation({
    update(cache, response) {
      const surveyEmployeeResponseId =
        response.data?.engagementSurveys.answerEngagementSurveyQuestion.record
          ?.flair__Engagement_Survey_Employee_Response__c;
      const newAnswer =
        response.data?.engagementSurveys.answerEngagementSurveyQuestion.record;

      if (!surveyEmployeeResponseId || !newAnswer) {
        return;
      }
      const surveyEmployeeResponseCacheId = cache.identify({
        Id: surveyEmployeeResponseId,
        __typename: 'EngagementSurveyEmployeeResponse',
      });
      const newAnswerReference: Reference = cache.writeFragment({
        data: newAnswer,
        fragment: EngagementSurveyQuestionAnswerFragmentDoc,
        fragmentName: 'engagementSurveyQuestionAnswer',
      }) as Reference;
      if (!newAnswerReference) {
        return;
      }

      cache.modify({
        id: surveyEmployeeResponseCacheId,
        fields: {
          questionsAnswers(existent) {
            if (!Array.isArray(existent)) {
              return existent;
            }
            const isExists = existent.some(
              (item: Reference) => item.__ref === newAnswerReference.__ref,
            );
            if (isExists) {
              return existent;
            }
            return [...existent, newAnswerReference];
          },
        },
      });
    },
  });
};
